import React, { Fragment } from 'react';
import Card from '@material-ui/core/Card';

import { CardText } from 'material-ui/Card';
import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';
import { Column } from 'react-virtualized';
import { toFriendlyDateString, formatHoursDays } from 'helpers/Formatter';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '0',
  },
};

export const TicketsTable = ({ graphData, level, goToTicket, timePeriod }) => {
  if (graphData[level].ticket_ids.length === 0) return null;
  if (graphData[level].child_type !== 'tickets') return null;
  const tableTitle = graphData[level]
    ? `${graphData[level].insight_type} ${graphData[level].insight_type_name} Maintenance Tickets`
    : 'Maintenance Tickets';

  const getTableData = () => {
    let resultArray = [];
    graphData[level].ticket_ids.forEach(child => {
      let index = resultArray.findIndex(x => x.id === parseInt(child['id'], 10));
      if (index <= -1) {
        resultArray.push({
          id: parseInt(child['id'], 10),
          insight_id: child['insight_id'],
          subject: child['subject'],
          created_at: new Date(child['created_at'] * 1000),
          completion_date: child['completion_date']
            ? new Date(child['completion_date'] * 1000)
            : '',
          satisfaction_rating:
            parseInt(child['satisfaction_rating'], 10) === 0 ? '' : child['satisfaction_rating'],
          priority: child['priority'],
          category: child['category'],
          ticket_number: parseInt(child['ticket_number'], 10),
          time_to_fix: formatHoursDays(child['time_to_fix'], timePeriod),
        });
      }
    });
    return resultArray;
  };

  const viewTicketDetails = (event, ticketId) => {
    // Because we have two onClick functions (one for the row, and one for
    // the row button), we want to prevent both from triggering
    if (event._dispatchListeners.length === 2) return;
    goToTicket(ticketId);
  };

  return (
    <div className="col-sm-12">
      <div className="row">
        <h3 style={{ padding: '0 15px', marginBottom: '20px' }}>{tableTitle}</h3>
      </div>
      <div className="row" style={{ padding: '0' }}>
        <Card style={style.transactionCard}>
          <CardText expandable={true} style={{ padding: '0', height: '300px' }}>
            <Fragment>
              <ReactVirtualizedTable
                data={getTableData()}
                rowRenderer={defaultRowRenderer}
                onRowClick={({ rowData, event }) => viewTicketDetails(event, rowData.id)}
              >
                <Column width={50} label="No." dataKey="ticket_number" />
                <Column width={200} label="Subject" dataKey="subject" />
                <Column
                  width={150}
                  label="Created Date"
                  dataKey="created_at"
                  cellRenderer={({ cellData }) => toFriendlyDateString(cellData)}
                />
                <Column
                  width={150}
                  label="Completed Date"
                  dataKey="completion_date"
                  cellRenderer={({ cellData }) => toFriendlyDateString(cellData)}
                />
                <Column width={120} label={`Time fix (${timePeriod})`} dataKey="time_to_fix" />
                <Column width={100} label="Satisfaction" dataKey="satisfaction_rating" />
                <Column width={100} label="Priority" dataKey="priority" />
                <Column width={100} label="Category" dataKey="category" />
              </ReactVirtualizedTable>
            </Fragment>
          </CardText>
        </Card>
      </div>
    </div>
  );
};
